import React from "react";

import { getCurrentTime } from "../api";

export const useCurrentTime = () => {
  const [currentTime, setCurrentTime] = React.useState(null);

  React.useEffect(() => {
    const fetchCurrentTime = async () => {
      try {
        const response = await getCurrentTime();
        setCurrentTime(response.currentTime);
      } catch (error) {
        console.error('Error fetching current time:', error);
      }
    };

    fetchCurrentTime();
    const intervalId = setInterval(fetchCurrentTime, 60000); // Update every minute

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return currentTime;
}